import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function RequiredElementsIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 41.635 64"
  }, props, {
    contextType: contextType,
    className: `pi pi-required-elements-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30.793 12.05h-19.95c-5.509 0-9.975 4.466-9.975 9.975v19.95c0 5.509 4.466 9.975 9.975 9.975h19.95c5.509 0 9.975-4.466 9.975-9.975v-19.95c0-5.509-4.466-9.975-9.975-9.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCE",
    d: "M31.226 12.917c4.783 0 8.674 3.891 8.674 8.674v20.818c0 4.783-3.891 8.674-8.674 8.674H10.409c-4.783 0-8.674-3.891-8.674-8.674V21.591c0-4.783 3.891-8.674 8.674-8.674h20.817m0-1.735H10.409C4.66 11.182 0 15.843 0 21.591v20.818c0 5.749 4.66 10.409 10.409 10.409h20.818c5.749 0 10.409-4.66 10.409-10.409V21.591c-.001-5.748-4.661-10.409-10.41-10.409z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C32327",
    d: "M23.172 23.326l-.742 6.664 6.754-1.884.598 4.565-6.158.433 4.039 5.379-4.111 2.192-2.825-5.668-2.48 5.631-4.274-2.155 4.002-5.379-6.121-.47.707-4.528 6.61 1.884-.742-6.664h4.743z"
  })));
}